// Add your custom JS here.
jQuery(function ($) {

$('.fadeInUpTrigger').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).addClass('animate__animated animate__fadeInUp');
    } 
    
  });
});  

